"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProvider = void 0;
var TezosRpcNodes = {
    mainnet: "https://rpc.tzstats.com",
    granadanet: "https://rpc.granada.tzstats.com",
    hangzhounet: "https://rpc.hangzhou.tzstats.com",
    ithacanet: "https://rpc.ithaca.tzstats.com"
};
var getProvider = function (name) {
    return TezosRpcNodes[name];
};
exports.getProvider = getProvider;
//# sourceMappingURL=Networks.js.map